import { render, staticRenderFns } from "./CurrentDeals.vue?vue&type=template&id=5af41ed3&scoped=true&"
import script from "./CurrentDeals.vue?vue&type=script&lang=js&"
export * from "./CurrentDeals.vue?vue&type=script&lang=js&"
import style0 from "./CurrentDeals.vue?vue&type=style&index=0&id=5af41ed3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af41ed3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
